import React, { FC } from 'react';
import { Box } from '@material-ui/core';
import { TypographyWrapper } from '../../components';
import { TypographyWeight } from '../../components/TypographyWrapper/TypographyWrapper';

const SUBPROCESSORS = [
  {
    subprocessor: 'Alloy Automation',
    description: 'Workflow automation and integration platform',
    location: 'USA',
  },
  {
    subprocessor: 'Heroku',
    description: 'Cloud Hosted Infrastructure and Data Hosting',
    location: 'USA',
  },
  {
    subprocessor: 'Stripe',
    description: 'Payment processing and financial transactions',
    location: 'USA',
  },
  {
    subprocessor: 'Frenzy',
    description: 'AI-powered personalization and product recommendation',
    location: 'USA',
  },
  { subprocessor: 'Sharetribe', description: 'Marketplace platform', location: 'USA' },
  {
    subprocessor: 'Zendesk',
    description: 'Customer service platform for managing support tickets and interactions',
    location: 'USA',
  },
  {
    subprocessor: 'Heap',
    description: 'User behavior analytics to enhance product experience',
    location: 'USA',
  },
  {
    subprocessor: 'Seel',
    description: 'Product protection and extended warranty management',
    location: 'USA',
  },
  {
    subprocessor: 'Shippo',
    description: 'Shipping management and carrier integration for order fulfillment',
    location: 'USA',
  },
  {
    subprocessor: 'SendGrid',
    description: 'Email delivery for transactional and marketing communications',
    location: 'USA',
  },
  {
    subprocessor: 'Datadog',
    description: 'Monitoring and observability for application and infrastructure performance',
    location: 'USA',
  },
  {
    subprocessor: 'Shopify',
    description: 'Order and inventory syncing',
    location: 'USA',
  },
  {
    subprocessor: 'Retool',
    description: 'Internal Tooling',
    location: 'USA',
  },
  {
    subprocessor: 'Sentry',
    description: 'Error monitoring and observability',
    location: 'USA',
  },
  {
    subprocessor: 'Google Analytics',
    description: 'User behavior analytics to enhance product experience',
    location: 'USA',
  },
];

interface SubprocessorDataCellProps {
  children?: any;
  isHeader?: boolean;
}

const SubprocessorDataCell: FC<SubprocessorDataCellProps> = ({ children, isHeader = false }) => (
  <td style={{ border: '1px solid #ccc' }}>
    <Box m={1}>
      <TypographyWrapper
        weight={isHeader ? TypographyWeight.Bold : undefined}
        variant={isHeader ? 'subtitle1' : 'body2'}
      >
        {children}
      </TypographyWrapper>
    </Box>
  </td>
);

interface SubprocessorRowProps {
  subprocessor: string;
  description: string;
  location: string;
}
const SubprocessorRow: FC<SubprocessorRowProps> = ({ subprocessor, description, location }) => (
  <tr style={{ border: '1px solid #ccc' }}>
    <SubprocessorDataCell>{subprocessor}</SubprocessorDataCell>
    <SubprocessorDataCell>{description}</SubprocessorDataCell>
    <SubprocessorDataCell>{location}</SubprocessorDataCell>
  </tr>
);

const Subprocessors: FC = () => (
  <>
    <Box mb={3}>
      <TypographyWrapper variant="body1">Last Updated: October 21, 2024</TypographyWrapper>
    </Box>
    <Box mb={2}>
      <TypographyWrapper variant="body2">
        Treet engages with third-party subprocessors and affiliates to help us provide services to
        our customers.
      </TypographyWrapper>
    </Box>
    <table style={{ width: '100%', border: '1px solid #ccc', borderCollapse: 'collapse' }}>
      <thead>
        <tr>
          <SubprocessorDataCell isHeader>Subprocessor</SubprocessorDataCell>
          <SubprocessorDataCell isHeader>Description</SubprocessorDataCell>
          <SubprocessorDataCell isHeader>Location</SubprocessorDataCell>
        </tr>
      </thead>
      <tbody>
        {SUBPROCESSORS.map((row) => (
          <SubprocessorRow
            key={row.subprocessor}
            subprocessor={row.subprocessor}
            description={row.description}
            location={row.location}
          />
        ))}
      </tbody>
    </table>
  </>
);

export default Subprocessors;
